import { Box, BoxProps } from '@mui/material';
import { THUMBNAIL_BORDER_SIZE } from '../consts';

/**
 * Separate thumb frame from the sprite/placeholder content so border size
 * does not affect background-position math inside the thumbnail image.
 * Letterbox fill: pure black in light mode, app canvas in dark mode.
 */
export function ThumbnailFrame({ sx, ...props }: BoxProps) {
  return (
    <Box
      {...props}
      sx={{
        borderRadius: 1,
        border: `${THUMBNAIL_BORDER_SIZE}px solid`,
        borderColor: 'divider',
        // Video letterboxing / unpainted gaps. Light keeps a true black screen;
        // dark uses the app canvas so thumbs are less of a pure void.
        bgcolor: (theme) => (theme.palette.mode === 'dark' ? 'background.default' : 'common.black'),
        // Do not paint under the semi-transparent divider border (otherwise
        // rgba divider reads as a solid dark rim over the letterbox fill).
        backgroundClip: 'padding-box',
        lineHeight: 0,
        flexShrink: 0,
        overflow: 'hidden',
        ...sx,
      }}
    />
  );
}
